import { styled } from '@mui/material'
import Card from '@mui/material/Card'

export const StyledCard = styled(Card)(({ theme }) => ({
   width: 160,
   height: 160,
   display: 'flex',
   justifyContent: 'center',
   alignItems: 'center',
   borderRadius: 5,
   '&:hover': {
      boxShadow: `0 0 1.5em ${theme.palette.primary.dark}`,
   },
}))
export const StyledImg = styled('img')({
   height: 25,
   filter: 'grayscale(1)',
   opacity: 0.6,
})
